/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listHelps = /* GraphQL */ `
  query ListHelps($limit: Int, $nextToken: String) {
    listHelps(limit: $limit, nextToken: $nextToken) {
      items {
        description
        id
        link
        order
        title
      }
      nextToken
    }
  }
`;
export const listJobs = /* GraphQL */ `
  query ListJobs($limit: Int, $nextToken: String) {
    listJobs(limit: $limit, nextToken: $nextToken) {
      items {
        contentType
        createdAt
        id
        jobIdentity
        jobName
        jobOwner
        jobStatus
        languageSource
        languageTargets
        sourceKey
        sourceStatus
        translateCallback
        translateKey
        translateStatus
      }
      nextToken
    }
  }
`;
